<template>
  <div id="app">
    <!-- 根据屏幕宽度显示不同的导航栏 -->
    <NavbarDesktop v-if="!isMobile" />
    <NavbarMobile v-else />
    <!-- <footerBox></footerBox> -->
    <router-view />
  </div>
</template>

<script>
import NavbarDesktop from "./components/NavbarDesktop.vue"
import NavbarMobile from "./components/NavbarMobile.vue"
// import footerBox from './components/footerBox.vue'
export default {
  name: "App",
  components: {
    NavbarDesktop,
    NavbarMobile,
    // footerBox
  },
  data() {
    return {
      isMobile: false,
    }
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 992
    },
  },
  created() {
    this.checkScreenSize()
    window.addEventListener("resize", this.checkScreenSize)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize)
  },
}
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  overflow-x: hidden;
}
</style>
